import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMediaIconWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.media-icon-white-st0{clip-path:url(#SVGID_00000003073965468303763380000006571563262321142407_);}\n	.media-icon-white-st1{fill:#1557b5;enable-background:new    ;}\n	.media-icon-white-st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n	.media-icon-white-st3{fill:#FFFFFF;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("rect", {
			id: "SVGID_1_",
			width: 24,
			height: 24
		}) }),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "SVGID_00000140702298119385464740000014654786072499831206_",
			children: /* @__PURE__ */ _jsx("use", {
				xlinkHref: "#SVGID_1_",
				style: { overflow: "visible" }
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { clipPath: "url(#SVGID_00000140702298119385464740000014654786072499831206_)" },
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "media-icon-white-st2",
					d: "M20.2,4.5H3.8C3.3,4.5,3,4.8,3,5.2v13.5c0,0.4,0.3,0.8,0.8,0.8h16.5c0.4,0,0.8-0.3,0.8-0.8V5.2 C21,4.8,20.7,4.5,20.2,4.5z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "media-icon-white-st2",
					d: "M3,15.8L7.7,11C7.8,11,7.9,10.9,8,10.9c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2l4.2,4.2 c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2l1.9-1.9c0.1-0.1,0.2-0.1,0.2-0.2 c0.1,0,0.2-0.1,0.3-0.1s0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2l4,4"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "media-icon-white-st3",
					d: "M14.6,10.5c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1s-1.1,0.5-1.1,1.1S14,10.5,14.6,10.5z"
				})
			]
		})
	] })]
});
export default SvgMediaIconWhite;
